import { render, staticRenderFns } from "./SurfacesTable.vue?vue&type=template&id=2c0edd31&"
import script from "./SurfacesTable.vue?vue&type=script&lang=js&"
export * from "./SurfacesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports